import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

import moment from 'moment';
declare var require: any
declare var $: any
declare var Chart: any


@Component({
  selector: 'app-worker-stats',
  templateUrl: './worker-stats.component.html',
  styleUrls: ['./worker-stats.component.scss']
})
export class WorkerStatsComponent implements OnInit {

  stats: any;
  workers: any[] = [];
  viewMode: 'table' | 'graphs' = 'graphs';
  sortColumn = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  activeOnly = true;

  monitor = '';
  group = '';

  monitors:any = [];
  groups:any = [];

  filter: any;
  selected: any;

  u = Utils;
  Math = Math;

  charts: any[] = [];

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    const saved = localStorage.getItem('workerStatsFilter');
    if (saved) {
      try {
        const f = JSON.parse(saved);
        this.selected = {
          startDate: moment(f.start),
          endDate: moment(f.end)
        };
        this.monitor = f.monitor || '';
        this.group = f.group || '';
      } catch (e) {
        this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };
      }
    } else {
      this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };
    }

    this.getWorkers();

  }

  getWorkers(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    this.filter = [];
    this.filter['start'] = this.selected.startDate.format("YYYY-MM-DD");
    this.filter['end'] = this.selected.endDate.format("YYYY-MM-DD");

    this.okService.get('reports/workerstats',{monitor:this.monitor,group:this.group,start:this.filter['start'],end:this.filter['end']})
    .subscribe((data) => {

      this.stats = data.body;
      this.groups = this.okService.groups;
      this.monitors = this.okService.monitors;

      this.workers = Object.entries(this.stats)
        .map(([id, w]: [string, any]) => ({ id, ...w }))
        .sort((a, b) => (b['Shifts'] || 0) - (a['Shifts'] || 0));

      if (this.viewMode === 'graphs') {
        setTimeout(() => this.createCharts(), 0);
      }

    });
  }

  createCharts() {
    this.destroyCharts();

    const workers = this.filteredWorkers;
    if (workers.length === 0) return;

    const names = workers.map(w => w.name);
    const dateRange = this.selected.startDate.format('D MMM YYYY') + ' - ' + this.selected.endDate.format('D MMM YYYY');
    const barOptions = {
      indexAxis: 'y' as const,
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: { beginAtZero: true, stacked: false, ticks: { precision: 0 } },
        y: { stacked: false }
      }
    };

    const shiftsCanvas = document.getElementById('chartShifts') as HTMLCanvasElement;
    if (shiftsCanvas) {
      this.charts.push(new Chart(shiftsCanvas, {
        type: 'bar',
        data: {
          labels: names,
          datasets: [{
            label: 'Shifts',
            data: workers.map(w => w['Shifts'] || 0),
            backgroundColor: '#24CB0A'
          }]
        },
        options: {
          ...barOptions,
          plugins: {
            title: { display: true, text: 'Shifts per Worker (' + dateRange + ')', font: { size: 14 } },
            legend: { display: false }
          }
        }
      }));
    }

    const alertsCanvas = document.getElementById('chartAlerts') as HTMLCanvasElement;
    if (alertsCanvas) {
      this.charts.push(new Chart(alertsCanvas, {
        type: 'bar',
        data: {
          labels: names,
          datasets: [
            { label: 'Help', data: workers.map(w => w['Alert Help'] || 0), backgroundColor: '#dc3545' },
            { label: 'Missed Check In', data: workers.map(w => w['Alert Missed Check In'] || 0), backgroundColor: '#f79320' },
            { label: 'Missed High Risk', data: workers.map(w => w['Alert Missed High Risk'] || 0), backgroundColor: '#6f42c1' },
            { label: 'Man Down', data: workers.map(w => w['Alert Man Down'] || 0), backgroundColor: '#8b0000' },
            { label: 'Timed Activity', data: workers.map(w => w['Alert Timed Activity'] || 0), backgroundColor: '#0d6efd' },
            { label: 'Other', data: workers.map(w => w['Alert Other'] || 0), backgroundColor: '#6c757d' }
          ]
        },
        options: {
          ...barOptions,
          scales: {
            x: { beginAtZero: true, stacked: true, ticks: { precision: 0 } },
            y: { stacked: true }
          },
          plugins: {
            title: { display: true, text: 'Alert Breakdown per Worker (' + dateRange + ')', font: { size: 14 } },
            legend: { display: true, position: 'top' as const }
          }
        }
      }));
    }

    const doughnutCanvas = document.getElementById('chartDoughnut') as HTMLCanvasElement;
    if (doughnutCanvas) {
      const alertTypes = [
        { label: 'Help', key: 'Alert Help', color: '#dc3545' },
        { label: 'Missed Check In', key: 'Alert Missed Check In', color: '#f79320' },
        { label: 'Missed High Risk', key: 'Alert Missed High Risk', color: '#6f42c1' },
        { label: 'Man Down', key: 'Alert Man Down', color: '#8b0000' },
        { label: 'Timed Activity', key: 'Alert Timed Activity', color: '#0d6efd' },
        { label: 'Other', key: 'Alert Other', color: '#6c757d' }
      ];
      const totals = alertTypes.map(t => workers.reduce((sum, w) => sum + (w[t.key] || 0), 0));

      this.charts.push(new Chart(doughnutCanvas, {
        type: 'doughnut',
        data: {
          labels: alertTypes.map(t => t.label),
          datasets: [{
            data: totals,
            backgroundColor: alertTypes.map(t => t.color)
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: { display: true, text: 'Alert Type Distribution (' + dateRange + ')', font: { size: 14 } },
            legend: { display: true, position: 'right' as const }
          }
        }
      }));
    }
  }

  downloadChart(canvasId: string, filename: string) {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    if (!canvas) return;
    const link = document.createElement('a');
    link.download = filename + '.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  }

  switchView() {
    if (this.viewMode === 'table') {
      this.viewMode = 'graphs';
      setTimeout(() => this.createCharts(), 0);
    } else {
      this.destroyCharts();
      this.viewMode = 'table';
    }
  }

  destroyCharts() {
    this.charts.forEach(c => c.destroy());
    this.charts = [];
  }

  get filteredWorkers(): any[] {
    if (this.activeOnly) {
      return this.workers.filter(w => w['Shifts'] > 0);
    }
    return this.workers;
  }

  sortBy(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    const dir = this.sortDirection === 'asc' ? 1 : -1;
    this.workers.sort((a, b) => {
      const valA = a[column] ?? '';
      const valB = b[column] ?? '';
      if (typeof valA === 'number' && typeof valB === 'number') {
        return (valA - valB) * dir;
      }
      return String(valA).localeCompare(String(valB)) * dir;
    });
  }

  getTotal(field: string): number {
    return Math.round(this.filteredWorkers.reduce((sum, w) => sum + (Number(w[field]) || 0), 0));
  }

  updateFilter(){
    localStorage.setItem('workerStatsFilter', JSON.stringify({
      start: this.selected.startDate.format('YYYY-MM-DD'),
      end: this.selected.endDate.format('YYYY-MM-DD'),
      monitor: this.monitor,
      group: this.group
    }));
    this.getWorkers();
  }

  clearFilter(){
    this.monitor = '';
    this.group = '';
    this.activeOnly = true;
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };
    localStorage.removeItem('workerStatsFilter');
    this.getWorkers();
  }

  export(){

    if(this.monitor == null){
      this.monitor = '';
    }

    if(this.group == null){
      this.group = '';
    }

    let fields:any = {'export':true};
    fields['start'] = this.selected.startDate.format("YYYY-MM-DD");
    fields['end'] = this.selected.endDate.format("YYYY-MM-DD");
    fields['monitor'] = this.monitor;
    fields['group'] = this.group;


    this.okService.download("reports/workerstats",fields);

  }

}
